import {
ADD_ALERT
} from "@/store/_actiontypes";
import PersonalizerApi from "@/services/personalizer_api";
import {
    GET_GPT_SESSIONS,
    GET_SESSION_COUNT_PER_PROFILE
} from "@/store/_actiontypes";
import {
} from "@/store/_mutationtypes";

import { updateLoaderTo } from "./account";
import { UPDATE_GPT_SESSION } from "../_actiontypes";

const state = {};

const actions = {
    [GET_GPT_SESSIONS]({ commit, dispatch }, { project_id, params }) {
        updateLoaderTo(true);
       const params_string = new URLSearchParams(params).toString();
        return new Promise((resolve, reject) => {
            PersonalizerApi.get(`gpt/sessions?${params_string}`,
                {
                    headers: {
                        "project-id": project_id,
                    },
                }
            ).then(
                    (response) => {
                        updateLoaderTo(false);
                        resolve(response);
                    },
                    (error) => {
                        updateLoaderTo(false);
                        reject(error);
                        dispatch(
                            `alert/${ADD_ALERT}`,
                            { message: error?.response?.data?.detail?.response, color: "error" },
                            { root: true }
                          );
                    }
                );
        });
    },
    [UPDATE_GPT_SESSION]({ commit, dispatch }, { project_id, session_id, params }) {
        updateLoaderTo(true);
        return new Promise((resolve, reject) => {
            PersonalizerApi.patch(`gpt/sessions/${session_id}`, params,
                {
                    headers: {
                        "project-id": project_id,
                    },
                }
            ).then(
                    (response) => {
                        updateLoaderTo(false);
                        resolve(response);
                    },
                    (error) => {
                        updateLoaderTo(false);
                        reject(error);
                        dispatch(
                            `alert/${ADD_ALERT}`,
                            { message: error?.response?.data?.detail?.response, color: "error" },
                            { root: true }
                          );
                    }
                );
        });
    },
    [GET_SESSION_COUNT_PER_PROFILE]({ commit, dispatch }, { project_id, maira_profile_id, start_date, end_date }) {
        updateLoaderTo(true);
        return new Promise((resolve, reject) => {
            const params = new URLSearchParams();
            if (start_date) {
                params.append("start_date", start_date);
            }
            if (end_date) {
                params.append("end_date", end_date);
            }

            PersonalizerApi.get(`gpt/sessions/${maira_profile_id}/count${params.toString() ? `?${params.toString()}` : ""}`,
                {
                    headers: {
                        "project-id": project_id,
                    },
                }
            ).then(
                    (response) => {
                        updateLoaderTo(false);
                        resolve(response);
                    },
                    (error) => {
                        updateLoaderTo(false);
                        reject(error);
                        dispatch(
                            `alert/${ADD_ALERT}`,
                            { message: error?.response?.data?.detail?.response, color: "error" },
                            { root: true }
                          );
                    }
                );
        });
    },
};
const mutations = {};

export const session_list = {
    namespaced: true,
    state,
    actions,
    mutations,
};